// extracted by mini-css-extract-plugin
module.exports = {"root":"Splash_root__2OJ_H","logo":"Splash_logo__1BR-P","loader":"Splash_loader__urikp"};